export default [
  {
    //  神选民经历审判、试炼得着洁净的经历见证（1992年至今）
    path: "/spread-of-kingdom-gospel",
    name: "spread-of-kingdom-gospel",
    component: () =>
      import("@/views/spread-of-kingdom-gospel/1995-1999/index.vue"),
    meta: {
      title: "神选民经历审判、试炼得着洁净的经历见证（1992年至今）",
      order: 15,
      episode: "episode5",
      prefetchAssets: {
        isLoad: false,
        assets: [
          "images/six-trials-of-God-s-judgment-work/index/six-trials-of-God-s-judgment-work-bg-1.jpg",
        ],
      },
    },
  },
  {
    //  1995-1999
    path: "/spread-of-kingdom-gospel/1995-1999",
    name: "1995-1999",
    component: () =>
      import("@/views/spread-of-kingdom-gospel/1995-1999/index.vue"),
    meta: {
      title: "1995-1999",
      order: 16,
      episode: "episode5",
      prefetchAssets: {
        isLoad: false,
        assets: [],
      },
    },
  },
  {
    //  2000-2005
    path: "/spread-of-kingdom-gospel/2000-2005",
    name: "2000-2005",
    component: () =>
      import("@/views/spread-of-kingdom-gospel/2000-2005/index.vue"),
    meta: {
      title: "2000-2005",
      order: 17,
      episode: "episode5",
      prefetchAssets: {
        isLoad: false,
        assets: [],
      },
    },
  },
  {
    //  2006-2013
    path: "/spread-of-kingdom-gospel/2006-2013",
    name: "2006-2013",
    component: () =>
      import("@/views/spread-of-kingdom-gospel/2006-2013/index.vue"),
    meta: {
      title: "2006-2013",
      order: 18,
      episode: "episode5",
      prefetchAssets: {
        isLoad: false,
        assets: [],
      },
    },
  },
  {
    //  2014
    path: "/spread-of-kingdom-gospel/2014-to-the-present",
    name: "2014-to-the-present",
    component: () =>
      import("@/views/spread-of-kingdom-gospel/2014-to-the-present/index.vue"),
    meta: {
      title: "2014",
      order: 19,
      episode: "episode5",
      prefetchAssets: {
        isLoad: false,
        assets: [],
      },
    },
  },
];
